import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from "../api.js";
import { toast } from 'react-toastify';

export const BookingHistorySlice = createAsyncThunk("admin/Booking-History",async ({id,dataSet}, { rejectWithValue }) => {
    try {
      const response = await api.BookingHistoryApi({id,dataSet});
      console.log("response:",response);
        return response.data;
    } catch (error) {
      console.error("API error:", error);
      return rejectWithValue(error.response?.data || { message: "An error occurred" });
    }
  }
);

const BookingSlice = createSlice({
  name: 'Booking',
  initialState: {
    UserCredLogin: [],
    loading: false,
    error: null,
    validationErrors: [],
  },
  reducers: {},
  extraReducers: (builder) => {

    const handlePendingState = (state,action) => {
      state.loading = true;
      state.error = null; 
      state.validationErrors = []; 
    }
    const handleRejectState = (state, action) => {
      state.loading = false;
      state.error = action.payload?.message || "An error occurred";
      state.validationErrors = action.payload?.errors || []; 
      toast.error(state.error);
    }

    builder
      .addCase(BookingHistorySlice.pending,handlePendingState)
      .addCase(BookingHistorySlice.fulfilled, (state, action) => {
        console.log("action",action)
        state.BookingHistoryList = action.payload.data;
        state.loading = false;
      })
      .addCase(BookingHistorySlice.rejected,handleRejectState);
  },
});


export default BookingSlice.reducer;
